import './App.css';
import Invoice from './components/Invoice';


function App() {
  
  return (
    <div className="App">
      <div className='background'>
        
      </div>
      <Invoice />
    </div>
  );
}

export default App;
